import {
  Flex,
  Image,
  Text,
  useColorModeValue,
  useMediaQuery,
} from "@chakra-ui/react";
import {
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsFillChatFill,
  BsFillMicFill,
  BsFillMicMuteFill,
} from "react-icons/bs";
import { RiCheckboxBlankCircleFill, RiComputerFill } from "react-icons/ri";
import { MdGroup } from "react-icons/md";
import { ControlButtons } from "./ControlButtons";
import { GiSettingsKnobs } from "react-icons/gi";
import { useState } from "react";
import recordAnimation from "../../assets/record-animation.gif";
import useSmallScreen from "../useSmallScreen";

function MeetingControlLargeScreen({
  fullScreen,
  setShowChat,
  setShowFloatingParticipants,
  ...props
}) {
  const iconColor = useColorModeValue("#000", "#fff");
  const iconBoxColor = useColorModeValue("#fff", "#000");
  const [smallScreen] = useSmallScreen();
  const [muteMic, setMuteMic] = useState(true);
  const [showCam, setShowCam] = useState(true);
  const [startedRecording, setStartedRecording] = useState(false);

  return (
    <Flex
      width="100%"
      my="20px"
      justify="space-between"
      align={"center"}
      {...props}
    >
      {!smallScreen && (
        <Text
          p={!smallScreen ? "15px 25px" : "5px"}
          borderRadius={"10px"}
          color="#294566"
          bg="#fff"
          fontWeight={"800"}
          textAlign="center"
          fontSize={".8em"}
          mr={fullScreen && !smallScreen ? "15%" : "unset"}
        >
          ID: 142536347
        </Text>
      )}
      <ControlButtons
        total={"5"}
        icon={<BsFillChatFill />}
        color={iconColor}
        bg={iconBoxColor}
        onClick={() => setShowChat(true)}
      />
      <ControlButtons
        onClick={() => setMuteMic((prev) => !prev)}
        icon={muteMic ? <BsFillMicMuteFill /> : <BsFillMicFill />}
        color={muteMic ? "#fff" : "#000"}
        bg={muteMic ? "#FF4246" : "#fff"}
      />

      <ControlButtons
        onClick={() => setShowCam((prev) => !prev)}
        icon={
          showCam ? <BsFillCameraVideoFill /> : <BsFillCameraVideoOffFill />
        }
        color={showCam ? "#000" : "#fff"}
        bg={showCam ? "#fff" : "#FF4246"}
      />

      <ControlButtons
        icon={<RiComputerFill />}
        color={iconColor}
        bg={iconBoxColor}
      />

      {startedRecording ? (
        <ControlButtons
          onClick={() => setStartedRecording((prev) => !prev)}
          icon={
            <Image
              borderRadius={"6px"}
              w="25px"
              src={recordAnimation}
              alt="record animation"
            />
          }
          color="#1492E6"
          bg="#fff"
        />
      ) : (
        <ControlButtons
          onClick={() => setStartedRecording((prev) => !prev)}
          icon={
            <RiCheckboxBlankCircleFill
              color="#fff"
              fontSize={smallScreen ? ".6em" : "unset"}
            />
          }
          color="#1492E6"
          bg="#0076FF"
        />
      )}

      <ControlButtons
        icon={<MdGroup fontSize={"1.3em"} />}
        color={iconColor}
        bg={iconBoxColor}
        total={"36"}
        onClick={() => {
          //only show floating participants, if user switch to fullscreen
          if (fullScreen) {
            setShowFloatingParticipants((prev) => !prev);
          }
        }}
      />
      <ControlButtons
        icon={<GiSettingsKnobs />}
        color={iconColor}
        bg={iconBoxColor}
      />

      <Text
        ml={fullScreen && !smallScreen ? "15%" : "unset"}
        p={!smallScreen ? "15px 25px" : "5px"}
        borderRadius={"10px"}
        color="#FF5E61"
        bg="#fff"
        cursor="pointer"
        fontWeight={"800"}
        textAlign="center"
        fontSize={".8em"}
      >
        Leave Meeting
      </Text>
    </Flex>
  );
}

export default MeetingControlLargeScreen;
